/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdministeredDrugHistory } from './AdministeredDrugHistory';
import {
    AdministeredDrugHistoryFromJSON,
    AdministeredDrugHistoryFromJSONTyped,
    AdministeredDrugHistoryToJSON,
} from './AdministeredDrugHistory';
import type { AdministeredDrugValue } from './AdministeredDrugValue';
import {
    AdministeredDrugValueFromJSON,
    AdministeredDrugValueFromJSONTyped,
    AdministeredDrugValueToJSON,
} from './AdministeredDrugValue';

/**
 * 
 * @export
 * @interface AdministeredDrug
 */
export interface AdministeredDrug {
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrug
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrug
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrug
     */
    patient_id: string;
    /**
     * 
     * @type {AdministeredDrugValue}
     * @memberof AdministeredDrug
     */
    value: AdministeredDrugValue;
    /**
     * 
     * @type {Array<AdministeredDrugHistory>}
     * @memberof AdministeredDrug
     */
    history?: Array<AdministeredDrugHistory>;
    /**
     * 
     * @type {boolean}
     * @memberof AdministeredDrug
     */
    read?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdministeredDrug
     */
    scheduled?: boolean;
}

/**
 * Check if a given object implements the AdministeredDrug interface.
 */
export function instanceOfAdministeredDrug(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "patient_id" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function AdministeredDrugFromJSON(json: any): AdministeredDrug {
    return AdministeredDrugFromJSONTyped(json, false);
}

export function AdministeredDrugFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdministeredDrug {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'patient_id': json['patient_id'],
        'value': AdministeredDrugValueFromJSON(json['value']),
        'history': !exists(json, 'history') ? undefined : ((json['history'] as Array<any>).map(AdministeredDrugHistoryFromJSON)),
        'read': !exists(json, 'read') ? undefined : json['read'],
        'scheduled': !exists(json, 'scheduled') ? undefined : json['scheduled'],
    };
}

export function AdministeredDrugToJSON(value?: AdministeredDrug | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'patient_id': value.patient_id,
        'value': AdministeredDrugValueToJSON(value.value),
        'history': value.history === undefined ? undefined : ((value.history as Array<any>).map(AdministeredDrugHistoryToJSON)),
        'read': value.read,
        'scheduled': value.scheduled,
    };
}

